export default {
    namespaced: true,
    state: () => ({
        category: "ChancellaryIncoming",
        statuses: [],
        counter: null,
    }),
    mutations: {
        SET_CATEGORY (state, payload){
            state.category = payload;
        },
        SET_STATUS (state, payload){
            let exists = state.statuses.find(x => x.category == state.category);

            if (exists) {
                exists.value = payload;
            } else {
                state.statuses.push({category: state.category, value: payload});
            }
        },
        SET_COUNTER (state, payload) {
            state.counter = payload;
        },
    },
    getters: {
        getCategory: (s) => s.category,
        getStatus: (s) => {
            const exists = s.statuses.find(x => x.category == s.category);
            if (exists)
                return exists.value;
            else {
                return "-10";
            }
        },
        getCounter: (s) => s.counter,
    }
}